import { render, staticRenderFns } from "./SeckillTable.vue?vue&type=template&id=2bb5affc&scoped=true"
import script from "./SeckillTable.vue?vue&type=script&lang=js"
export * from "./SeckillTable.vue?vue&type=script&lang=js"
import style0 from "./SeckillTable.vue?vue&type=style&index=0&id=2bb5affc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5affc",
  null
  
)

export default component.exports